import { createContext } from "react";
import type { SuggestionType } from "src/types/adapters/query.type";
import type { CarouselType } from "src/types/Carousels";

type SearchResultsDispatchState = {
  onSuggestionClick: ({
    gateLevel,
    itemId,
    position,
    type,
  }: {
    type: SuggestionType;
    itemId: string;
    position: number;
    gateLevel?: string;
  }) => void;
  onViewAllClick: (position: "header" | "bottom") => void;
  onSearchViewAllBrandsClick: () => void;
  onSearchRecommendationClick: (data: {
    type: CarouselType;
    name: string;
    position: number;
  }) => void;
  onShopTypeNavigate: () => void;
};

const SEARCH_RESULTS_CONTEXT_DISPATCH_STATE: SearchResultsDispatchState = {
  onSuggestionClick: () => {},
  onViewAllClick: () => {},
  onSearchRecommendationClick: () => {},
  onSearchViewAllBrandsClick: () => {},
  onShopTypeNavigate: () => {},
};

export const SearchResultsDispatchContext = createContext(
  SEARCH_RESULTS_CONTEXT_DISPATCH_STATE
);
